<template>
  <page
    :custom-style="{
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
      paddingBottom: '50px'
    }"
  >
    <!-- 提示 -->
    <van-notice-bar
      v-if="noticeTip"
      wrapable
      :scrollable="false"
      color="#ff9600"
      left-icon="warning-o"
      :text="noticeTip"
    />
    <!-- 门店 -->
    <div class="bill-top-info">
      <bill-company
        :page="'bill'"
        @selectCompany="selectCompany"
      ></bill-company>
      <bill-type :page="'bill'" @selectType="selectType"></bill-type>
    </div>

    <!-- tab -->
    <van-tabs
      v-model="activeTab"
      line-width="20px"
      :color="THEME_COLOR"
      :title-active-color="THEME_COLOR"
      @change="onTabChange"
    >
      <van-tab title="日账单" name="day" />
      <van-tab title="周账单" name="week" />
      <van-tab title="月账单" name="month" />
    </van-tabs>
    <div class="date-wrappr">
      <div>日期：</div>
      <!-- 时间范围选择 -->
      <div class="date" @click="onSelect">{{ selectedDateText }}</div>
    </div>

    <!-- 汇总面板 -->
    <div class="summary">
      <div v-if="result.amountTips" class="amount-tip">
        {{ result.amountTips }}
      </div>
      <div class="top">
        <div class="total">
          <div class="title">
            采买合计<van-icon
              class="tip"
              name="warning-o"
              color="#8c8c8c"
              @click="
                tip(
                  '采买合计说明',
                  '1、采买合计=下单金额+多退少补金额-售后退款金额\n2、下单金额包含包装物押金；采买合计金额可能和您实际支付金额不一致，例如：多退少补欠款未支付',
                  true
                )
              "
            />
          </div>
          <div class="value" :class="themeColorClass">
            {{ toFixd(result.purchaseAmount) }}
          </div>
          <div v-if="result.packDesc" class="pack-desc">
            {{ result.packDesc }}
          </div>
        </div>
        <div class="bill-btn" :class="themeBgColorClass" @click="goExport">
          导出明细
        </div>
        <div class="bill-btn list-btn" @click="goExportList">导出列表</div>
      </div>
      <div class="bottom">
        <div class="sub">
          <div class="title">
            下单金额<van-icon
              name="warning-o"
              class="tip"
              @click="tip('下单金额说明', '下单金额为下单时商品优惠后金额')"
            />
          </div>
          <div class="value">{{ toFixd(result.totalOrderAmount) }}</div>
        </div>
        <div class="sub">
          <div class="title">
            多退少补<van-icon
              name="warning-o"
              class="tip"
              @click="
                tip(
                  '多退少补说明',
                  '由于缺货或者生鲜商品的特性（如无法切割等），您实际收到的商品重量可能与您下单的重量存在差异，因此产生多退少补的差价。\n产生的退款会在收货后原路返回。\n产生的待补欠款可通过一下两种方式补交：\n1. 下次下单时补交\n2. 在【我的->欠款】中补交',
                  true
                )
              "
            />
          </div>
          <div
            class="value"
            :class="{ 'negative-value': result.totalDiffAmount < 0 }"
          >
            {{ toFixd(result.totalDiffAmount) }}
          </div>
        </div>
        <div class="sub">
          <div class="title">
            售后退款<van-icon
              name="warning-o"
              class="tip"
              @click="
                tip(
                  '售后退款说明',
                  '售后退款指由于拒收、售后产生的退款金额。\n实际退款金额与不同商品售后规则及欠款支付状态有关。\n退款规则可在【我的->退款/售后】中查看\n欠款明细可在【我的->欠款】中查看',
                  true
                )
              "
            />
          </div>
          <div
            class="value"
            :class="{ 'negative-value': result.totalRefundAmount < 0 }"
          >
            {{ toFixd(result.totalRefundAmount) }}
          </div>
        </div>
        <div class="sub">
          <div class="title">
            售后赔偿<van-icon
              name="warning-o"
              class="tip"
              @click="
                tip(
                  '售后赔偿说明',
                  '售后赔偿指由于商品质量、斤数等问题产生的赔偿金额',
                  true
                )
              "
            />
          </div>
          <div class="value">{{ toFixd(result.totalCompensateAmount) }}</div>
        </div>
      </div>
    </div>
    <!-- 日账单明细列表 -->
    <div v-if="result.deliveryDateList.length > 0" class="order-title">
      订单明细
    </div>
    <template v-if="result.deliveryDateList.length > 0">
      <deliver-order
        v-for="(deliveryItem, deliveryIndex) in result.deliveryDateList"
        :key="deliveryIndex"
        :delivery-item="deliveryItem"
      ></deliver-order>
    </template>

    <!-- 周月账单折线图 -->
    <div v-show="result.billDetails.length > 0" id="bill-charts"></div>
    <!-- 周月账单明细列表 -->
    <div v-if="result.billDetails.length > 0" class="order-list">
      <div class="order-list-title" @click="showDetail = !showDetail">
        订单明细<IconFont
          :name="showDetail ? 'arrow_up_m' : 'arrow_down_m'"
          size="0.2rem"
          color="#999"
        />
      </div>
      <div v-show="showDetail" class="order-list-content">
        <div
          v-for="(date, index) in result.billDetails"
          :key="index"
          class="order-list-date"
        >
          <div class="date-info">
            <div>{{ formatDay(date.dayTime) }}</div>
            <div>￥{{ toFixd(date.dayPurAmount) }}</div>
          </div>
          <div
            v-for="order in date.orderList"
            :key="order.orderId"
            class="order-info"
          >
            <div>订单编号：{{ order.orderId }}</div>
            <div>￥{{ toFixd(order.purAmount) }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 品类分析 -->
    <div v-show="categoryData.length > 0" class="category">
      <div id="category-charts"></div>
      <div class="category-list">
        <div class="title">全部分类</div>
        <div
          v-for="(item, index) in categoryData"
          :key="index"
          class="category-item"
        >
          <div class="category-item-left">
            <div class="name">
              <div class="text">{{ item.pmsClassName }}</div>
              <div class="percent">
                {{
                  categoryTotalAmount > 0
                    ? toFixd((item.purchaseAmount / categoryTotalAmount) * 100)
                    : 0
                }}%
              </div>
            </div>
            <div class="progress">
              <div
                class="value"
                :style="{
                  width: `${
                    categoryTotalAmount > 0
                      ? toFixd(
                          (item.purchaseAmount / categoryTotalAmount) * 100
                        )
                      : 0
                  }%`
                }"
              ></div>
            </div>
          </div>
          <div class="category-item-right">￥{{ item.purchaseAmount }}</div>
        </div>
      </div>
    </div>
    <!-- 日账单日历 -->
    <van-calendar
      v-model="showCalendar"
      title="选择日期"
      :color="THEME_COLOR"
      :min-date="minDate"
      :max-date="maxDate"
      :default-date="maxDate"
      @confirm="onConfirm"
    />
    <!-- 周月账单时间范围选择器 -->
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        ref="van_picker"
        class="bill-pick"
        show-toolbar
        :default-index="pickerDefaultIndex"
        :columns="pickerColumn"
        @cancel="showPicker = false"
        @confirm="onPickerConfirm"
      />
    </van-popup>
  </page>
</template>
<script>
import * as echarts from 'echarts/core'
import { API } from '@/api'
import { navBar } from '@/utils/native_interactions/native_bar'
import DeliverOrder from './components/DeliverOrder.vue'
import BillCompany from './components/BillCompany.vue'
import BillType from './components/BillType.vue'
import themeMixin from '@/common/mixins/theme'
import {
  isMCMallKeyCustomerIOS,
  isMCMallKeyCustomerAndroid
} from '@mc/mc-base-env/src/web/platform'
import { THEME_COLOR } from '@/defines/environment/config'
const current = new Date()
const categoryColor = [
  '#15bb5c',
  '#7992ff',
  '#61e0f1',
  '#ff7e7e',
  '#3451cb',
  '#ff8c23',
  '#ffc300',
  '#55a6eb',
  '#26bab7'
]
export default {
  name: 'BillIndex',
  components: {
    DeliverOrder,
    BillCompany,
    BillType
  },
  mixins: [themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = '我的账单'
      navBar.setTitle({
        text: '我的账单'
      })
      vm.getBillTip()
    })
  },
  data() {
    return {
      activeTab: 'day',
      showCalendar: false,
      showPicker: false,
      pickerDefaultIndex: 0,
      minDate: new Date(
        new Date(current.getFullYear(), current.getMonth(), current.getDate()) -
          365 * 24 * 60 * 60 * 1000
      ), // 最小时间范围
      maxDate: new Date(
        new Date(current.getFullYear(), current.getMonth(), current.getDate())
      ), // 最大时间范围
      selectedDate: null, // 选中的日（日账单使用）
      selectedStart: null, // 选中的起始时间（周月账单使用）
      selectedEnd: null, // 选中的结束时间（周月账单使用）
      weekList: [],
      monthList: [],
      showDetail: false,
      result: {
        purchaseAmount: 0,
        totalOrderAmount: 0,
        totalDiffAmount: 0,
        totalRefundAmount: 0,
        deliveryDateList: [],
        billDetails: [],
        amountTips: '',
        packDesc: ''
      },
      categoryData: [],
      categoryTotalAmount: 0,
      noticeTip: '',
      THEME_COLOR,
      selected_company_id: '',
      selected_type: 1
    }
  },

  computed: {
    pickerColumn() {
      return this.activeTab === 'week' ? this.weekList : this.monthList
    },
    selectedDateText() {
      if (this.activeTab === 'week') {
        return `${this.selectedStart.getFullYear()}年${
          this.selectedStart.getMonth() + 1
        }月${this.selectedStart.getDate()}日-${
          this.selectedEnd.getMonth() + 1
        }月${this.selectedEnd.getDate()}日`
      } else if (this.activeTab === 'month') {
        return `${this.selectedStart.getFullYear()}年${
          this.selectedStart.getMonth() + 1
        }月`
      } else {
        return `${this.selectedDate.getFullYear()}年${
          this.selectedDate.getMonth() + 1
        }月${this.selectedDate.getDate()}日`
      }
    }
  },
  async created() {
    this.selectedDate = new Date(this.maxDate.getTime())
  },
  mounted() {
    this._charts = echarts.init(document.getElementById('bill-charts'))
    this._categoryCharts = echarts.init(
      document.getElementById('category-charts')
    )
  },
  methods: {
    initData() {
      this.pickerDefaultIndex = 0
      this.maxDate = new Date(
        new Date(current.getFullYear(), current.getMonth(), current.getDate())
      )
      this.selectedDate = new Date(this.maxDate.getTime()) - 1000
    },
    selectCompany(companyId) {
      this.selected_company_id = companyId
      this.initData()
      this.onTabChange(this.activeTab)
    },

    selectType(type) {
      this.selected_type = type
      this.initData()
      this.onTabChange(this.activeTab)
    },
    async getBillTip() {
      const res = await API.tpPay.getBillTip()
      this.noticeTip = res?.tip || ''
      const minDate = res.minDate || ''
      const value = new Date(minDate)
      this.minDate = new Date(
        new Date(value.getFullYear(), value.getMonth(), value.getDate())
      )
    },

    onTabChange(name) {
      switch (name) {
        case 'day':
          this.$track(this.$trackMap.bill.dayTabClick)
          this.selectedDate = new Date(this.maxDate.getTime())
          if (this._charts) {
            this._charts.dispose()
            this._charts = null
          }
          this.fetchData()
          break
        case 'week': {
          this.$track(this.$trackMap.bill.weekTabClick)
          if (this.weekList.length === 0) this.getWeekList()
          const lastWeek = this.weekList[this.weekList.length - 1]
          this.selectedStart = lastWeek.start
          this.selectedEnd = lastWeek.end

          this.pickerDefaultIndex = this.weekList.length - 1
          if (this.$refs.van_picker) {
            this.$refs.van_picker.setIndexes([this.pickerDefaultIndex])
          }

          if (!this._charts)
            this._charts = echarts.init(document.getElementById('bill-charts'))
          this.fetchRangeData()
          break
        }
        case 'month': {
          this.$track(this.$trackMap.bill.monthTabClick)
          if (this.monthList.length === 0) this.getMonthList()
          const lastMonth = this.monthList[this.monthList.length - 1]
          this.selectedStart = lastMonth.start
          this.selectedEnd = lastMonth.end
          this.pickerDefaultIndex = this.monthList.length - 1
          if (this.$refs.van_picker) {
            this.$refs.van_picker.setIndexes([this.pickerDefaultIndex])
          }
          if (!this._charts)
            this._charts = echarts.init(document.getElementById('bill-charts'))
          this.fetchRangeData()
          break
        }
      }
    },
    // 获取周时间段
    getWeekList() {
      const { minDate, maxDate } = this
      let first = minDate
      let last = minDate
      const result = []
      while (last.getTime() < maxDate.getTime()) {
        const diff = 7 - first.getDay()
        last = new Date(first.getTime() + (diff + 1) * 24 * 3600 * 1000 - 1000)
        if (last.getTime() > maxDate.getTime()) {
          last = maxDate
        }
        result.push({
          start: first,
          end: last,
          text: `${first.getFullYear()}.${
            first.getMonth() + 1
          }.${first.getDate()}-${last.getMonth() + 1}.${last.getDate()}`
        })
        first = new Date(last.getTime() + 1000)
      }
      this.weekList = result
    },
    // 获取月时间段
    getMonthList() {
      const { minDate, maxDate } = this
      const minYear = minDate.getFullYear()
      const maxYear = maxDate.getFullYear()
      const minMonth = minDate.getMonth()
      const maxMonth = maxDate.getMonth()
      const result = []

      if (minYear !== maxYear) {
        // 处理起始年份
        let m = minMonth
        while (m <= 11) {
          let start = new Date(minYear, m, 1)
          const end = new Date(minYear, m + 1, 0) // 当月最后一天
          if (start < minDate) start = minDate
          result.push({ start, end, text: `${minYear}年${m + 1}月` })
          m++
        }

        // +++ 关键修复：处理中间年份 +++
        for (let year = minYear + 1; year < maxYear; year++) {
          for (let month = 0; month < 12; month++) {
            const start = new Date(year, month, 1)
            const end = new Date(year, month + 1, 0)
            result.push({ start, end, text: `${year}年${month + 1}月` })
          }
        }

        // 处理结束年份
        m = 0
        while (m <= maxMonth) {
          const start = new Date(maxYear, m, 1)
          let end = new Date(maxYear, m + 1, 0)
          if (end > maxDate) end = maxDate
          result.push({ start, end, text: `${maxYear}年${m + 1}月` })
          m++
        }
      } else {
        // 同一年份处理（原逻辑不变）
        let m = minMonth
        while (m <= maxMonth) {
          let start = new Date(minYear, m, 1)
          let end = new Date(minYear, m + 1, 0)
          if (start < minDate) start = minDate
          if (end > maxDate) end = maxDate
          result.push({ start, end, text: `${minYear}年${m + 1}月` })
          m++
        }
      }
      this.monthList = result
    },
    goExport() {
      this.$track(this.$trackMap.bill.goExport)
      let start, end
      switch (this.activeTab) {
        case 'day':
          start = this.selectedDate.getTime()
          end = this.selectedDate.getTime() + 24 * 60 * 60 * 1000 - 1000
          break
        case 'week':
        case 'month':
          start = this.selectedStart.getTime()
          end = this.selectedEnd.getTime()
          break
      }
      this.$router.push({
        path: '/bill_export',
        query: {
          start,
          end,
          selected_company_id: this.selected_company_id,
          selected_type: this.selected_type
        }
      })
    },
    goExportList() {
      this.$track(this.$trackMap.bill.exportGoDetail)
      this.$router.push({
        path: '/bill_export_list',
        query: {
          selected_company_id: this.selected_company_id
        }
      })
    },
    toFixd(num) {
      return Number(num).toFixed(2)
    },
    onSelect() {
      switch (this.activeTab) {
        case 'day':
          this.showCalendar = true
          break
        case 'week':
        case 'month': {
          this.showPicker = true
          break
        }
      }
    },
    tip(title, message, textLeft) {
      this.$dialog.alert({
        title,
        message: textLeft
          ? `<div style="text-align: left">${message}</div>`
          : message
      })
    },
    onConfirm(date) {
      this.selectedDate = date
      this.showCalendar = false
      this.fetchData()
      this.$track(this.$trackMap.bill.selectQueryDate)
    },
    onPickerConfirm(range, index) {
      const select = (
        this.activeTab === 'week' ? this.weekList : this.monthList
      )[index]
      this.selectedStart = select.start
      this.selectedEnd = select.end
      this.showPicker = false
      this.fetchRangeData()
      this.$track(this.$trackMap.bill.selectQueryDate)
    },
    formatDay(time) {
      const date = new Date(time)
      return `${date.getFullYear()}年${
        date.getMonth() + 1
      }月${date.getDate()}日`
    },
    // 查询日账单数据
    async fetchData() {
      this.$Loading()
      try {
        const res = await API.tpPay.queryDetailsByGroupDeliveryDate({
          queryTime: this.selectedDate.getTime(),
          selected_company_id: this.selected_company_id,
          queryType: this.selected_type
        })
        this.result = {
          purchaseAmount: res.purchaseAmount || 0,
          totalOrderAmount: res.totalOrderAmount || 0,
          totalDiffAmount: res.totalDiffAmount || 0,
          amountTips: res.amountTips || '',
          packDesc: res.packDesc || '',
          totalRefundAmount: res.totalRefundAmount || 0,
          totalCompensateAmount: res.totalCompensateAmount || 0,
          deliveryDateList: res.deliveryDateList || [],
          billDetails: []
        }
        this.fetchCategoryData()
      } catch (error) {
        this.$catch(error)
      }
      this.$Loading.hide()
    },
    // 查询周月账单数据
    async fetchRangeData() {
      this.$Loading()
      try {
        const res = await API.tpPay.queryBillRange({
          startTime: this.selectedStart.getTime(),
          endTime: this.selectedEnd.getTime(),
          selected_company_id: this.selected_company_id,
          queryType: this.selected_type
        })
        this.result = {
          purchaseAmount: res.purchaseAmount || 0,
          totalOrderAmount: res.totalOrderAmount || 0,
          totalDiffAmount: res.totalDiffAmount || 0,
          amountTips: res.amountTips || '',
          packDesc: res.packDesc || '',
          totalRefundAmount: res.totalRefundAmount || 0,
          totalCompensateAmount: res.totalCompensateAmount || 0,
          billDetails: res.billDetails || [],
          deliveryDateList: []
        }
        this.renderCharts()
        this.fetchCategoryData()
      } catch (error) {
        this.$catch(error)
      }
      this.$Loading.hide()
    },
    async fetchCategoryData() {
      try {
        const res = await API.tpPay.getBillAnalysis({
          startTime:
            this.activeTab === 'day'
              ? this.selectedDate.getTime()
              : this.selectedStart.getTime(),
          endTime:
            this.activeTab === 'day'
              ? this.selectedDate.getTime() + 24 * 60 * 60 * 1000 - 1000
              : this.selectedEnd.getTime(),
          selected_company_id: this.selected_company_id,
          queryType: this.selected_type
        })
        this.categoryData = res || []
        this.categoryTotalAmount = res.reduce((prev, cur) => {
          return prev + cur.purchaseAmount
        }, 0)
        this.renderCategoryCharts()
      } catch (error) {
        console.log(error)
        this.$catch(error)
      }
    },
    // 渲染折线图
    renderCharts() {
      const baseData = []
      let current = this.selectedStart
      const year = current.getFullYear()
      // const month = current.getMonth()
      while (current.getTime() < this.selectedEnd.getTime()) {
        const detail = this.result.billDetails.find(
          item => item.dayTime === current.getTime()
        )
        baseData.push({
          day: current,
          value: detail ? detail.dayPurAmount : 0
        })
        current = new Date(current.getTime() + 24 * 3600 * 1000)
      }
      this._charts.setOption({
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter: function (params) {
            const value = params[0].value
            const axisValue = params[0].axisValue
            const [monthPart, dayPart] = axisValue.split('.')
            const month = parseInt(monthPart)
            const day = parseInt(dayPart)
            // const dataIndex = params[0].dataIndex
            return `${year}年${month}月${day}日<br/>金额 ¥${value}`
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              type: 'solid',
              color: '#8c8c8c'
            },
            axis: 'x'
          },
          backgroundColor: '#15BB5C',
          padding: 3,
          textStyle: {
            color: '#fff'
          }
        },
        title: {
          show: true,
          text: '购买情况',
          textStyle: {
            color: '#262626',
            fontSize: 16
          },
          top: 16,
          left: 12
        },
        grid: {
          left: 12,
          containLabel: true,
          bottom: 20,
          top: 58,
          right: 27
        },
        xAxis: {
          type: 'category',
          data: baseData.map(item => {
            return `${item.day.getMonth() + 1}.${item.day.getDate()}`
          })
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: baseData.map(item => item.value),
            type: 'line',
            lineStyle: {
              normal: {
                color: '#15bb5c',
                width: 1
              }
            },
            itemStyle: {
              color: '#15bb5c',
              borderWidth: 1
            },
            label: {
              show: false
            }
          }
        ]
      })
    },

    renderCategoryCharts() {
      this._categoryCharts.setOption({
        title: {
          show: true,
          text: '品类分析',
          subtext: `品类分析中不包含包装物${
            isMCMallKeyCustomerIOS() || isMCMallKeyCustomerAndroid()
              ? ''
              : '押金及运费'
          }的金额统计`,
          textStyle: {
            color: '#262626',
            fontSize: 16
          },
          top: 16,
          left: 12
        },
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            name: '品类分析',
            type: 'pie',
            left: 12,
            bottom: 20,
            top: 66,
            right: 27,
            radius: ['50%', '80%'],
            label: {
              edgeDistance: '10%',
              overflow: 'break'
            },
            data: this.categoryData.map((item, index) => {
              const color = categoryColor[index]
              return {
                value: item.purchaseAmount,
                name: item.pmsClassName,
                itemStyle: { color },
                label: { color },
                labelLine: { lineStyle: { color } }
              }
            })
          }
        ]
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bill-top-info {
  @include flex-row-between;
  background-color: #fff;
}
.date-wrappr {
  padding: 0.24rem 0.7rem 0.24rem 0.4rem;

  font-size: 0.28rem;
  color: #262626;

  @include flex-row-between;
}
.date {
  position: relative;

  height: 0.4rem;

  line-height: 0.4rem;
  &:after {
    display: inline-block;

    position: absolute;
    top: 0.15rem;
    right: -0.3rem;

    border-width: 0.1rem;
    border-style: solid;
    border-top-color: #262626;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;

    font-size: 0;

    content: '';
  }
}
.bill-btn {
  width: 1.56rem;
  height: 0.48rem;

  background-color: #15bb5c;
  border-radius: 0.48rem;

  font-size: 0.24rem;
  line-height: 0.48rem;
  text-align: center;
  color: #fff;
  &.minor {
    margin-right: 0.16rem;

    background-color: #f5f5f5;

    color: #15bb5c;
  }
  &.list-btn {
    background-color: #fff;
    border: 1px solid #15bb5c;
    color: #15bb5c;
    margin-left: 8px;
  }
}
.category {
  width: 7rem;
  margin: 0.24rem auto;

  background-color: #fff;
  border-radius: 0.16rem;
  &-list {
    padding: 0 0.24rem 0.4rem;
    .title {
      font-size: 0.32rem;
      line-height: 0.44rem;
      font-weight: 600;
      color: #262626;
    }
    .category-item {
      display: flex;

      margin-top: 0.24rem;
      padding-bottom: 0.08rem;

      justify-content: space-between;
      align-items: flex-end;
    }
    .category-item-left {
      width: 4.4rem;
      .name {
        display: flex;

        justify-content: space-between;
        align-items: center;

        line-height: 0.4rem;

        color: #8c8c8c;
        .text {
          font-size: 0.28rem;
        }
        .percent {
          font-size: 0.24rem;
        }
      }
      .progress {
        width: 100%;
        height: 0.24rem;
        margin-top: 0.12rem;

        background-color: #ebebeb;
        border-radius: 0.12rem;
        .value {
          height: 0.24rem;

          background-color: #15bb5c;
          border-radius: 0.12rem;
        }
      }
    }
    .category-item-right {
      font-size: 0.28rem;
      color: #8c8c8c;
    }
  }
}
.summary {
  width: 7rem;
  margin: 0 auto;

  background-color: #fff;
  border-radius: 0.16rem;
  .tip {
    margin-left: 0.06rem;
  }
  .amount-tip {
    font-size: 0.28rem;
    color: #f03100;
    padding-top: 0.16rem /* 8/50 */;
    padding-left: 0.4rem;
  }
  .top {
    display: flex;

    height: 1.6rem;
    padding: 0 0.4rem;

    border-bottom: 1px solid #f5f5f5;

    align-items: center;
    .total {
      flex: auto;
      .title {
        font-size: 0.28rem;
        line-height: 0.4rem;
        color: #8c8c8c;
      }
      .value {
        font-size: 0.48rem;
        line-height: 0.66rem;
        color: #15bb5c;
      }
      .pack-desc {
        font-size: 0.24rem /* 12/50 */;
        color: #8c8c8c;
      }
    }
  }
  .bottom {
    display: flex;

    height: 1.3rem;
    padding: 0 0.4rem;

    justify-content: space-between;
    align-items: center;
    .sub {
      .title {
        font-size: 0.24rem;
        line-height: 0.34rem;
        color: #8c8c8c;
      }
      .value {
        font-size: 0.28rem /* 14/50 */;
        line-height: 0.44rem;
        color: #262626;
      }
      .negative-value {
        color: #f03100;
      }
    }
  }
}
.order-title {
  margin: 0.4rem 0 0.24rem 0.4rem;

  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #8c8c8c;
}

.order-list {
  width: 7rem;
  margin: 0.24rem auto;
  padding: 0 0.24rem;

  background-color: #fff;
  border-radius: 0.16rem;
  &-title {
    display: flex;

    justify-content: space-between;
    align-items: center;

    font-size: 0.32rem;
    line-height: 1rem;
    font-weight: 500;
    color: #262626;
  }
  &-content {
    padding-bottom: 0.3rem;

    border-top: 1px solid #f0f0f0;
  }
  &-date {
    padding: 0.16rem 0;
    .date-info {
      display: flex;

      height: 0.72rem;

      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      font-size: 0.28rem;
      font-weight: 500;
      color: #262626;
    }
    .order-info {
      display: flex;

      height: 0.72rem;

      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      font-size: 0.28rem;
      color: #888;
    }
  }
}
#bill-charts {
  width: 7rem;
  height: 5.4rem;
  margin: 0.24rem auto 0;

  background-color: #fff;
  border-radius: 0.16rem;
  z-index: 99;
}
.bill-pick {
  z-index: 100;
}
#category-charts {
  width: 7rem;
  height: 5.4rem;

  z-index: 99;
}
</style>
